import { useContext } from 'react';
import { experimentContext } from './TargetProvider';
import { mapTargetPrismicExperiments } from './mapTargetPrismicExperiments';

export default function useTargetPrismicExperiments() {
  const { loading, experiments } = useContext(experimentContext);

  const targetExperiments = mapTargetPrismicExperiments(experiments ?? []);

  return {
    loading,
    prismicIds: targetExperiments.map(e => ({
      id: e.prismicId,
      position: e.position,
      ...e.displayRules,
    })),
  };
}
